import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import {
  setDocumentTitle,
  getlang,
  setlang,
  inject,
  observer,
  closeWebview
} from '../../../helper/devTools.js'
import {
  jumpToWallet
} from 'src/helper/webviewFun'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    setDocumentTitle('GAMES')
  }
  state = {
    lang: langM.en,
    language: 'en'
  }

  async initLang() {
    let { language } = this.getQuery()
    language = await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    console.log('language', language)
  }

  async componentWillMount () {
    window.addEventListener(
      'message',
      async(e) => {
        if (e.data && e.data != '') {
          try {
            let d = JSON.parse(e.data)
            if (d.msgtp == 'popRecharge') {
              jumpToWallet(0)
              return   
            }
            if (d.msgtp == 'popClose') return closeWebview()
          } catch (error) {
            console.error(error)
          }
        }
      },
      false
    )
  }

  async componentDidMount() {
    this.initLang()
  }

  getQuery() {
    // 获取 hash 中的查询字符串部分
    let hash = window.location.hash
    let queryString = hash.includes('?') ? hash.split('?')[1] : ''

    // 将 URL 编码中的 \u0026 替换为 &
    let cleanQuery = decodeURIComponent(queryString).replace(/\\u0026/g, '&')

    // 解析参数
    let params = new URLSearchParams(cleanQuery)

    // 提取所需参数
    let uid = params.get('uid')
    let accesstoken = params.get('accesstoken')
    let GameURL = params.get('GameURL')
    let lang = params.get('lang')
    let sdk = params.get('sdk')
    let gameID = params.get('gameID')
    let gameEnv = params.get('game_env')

    // 输出结果
    console.log('uid:', uid)
    console.log('accesstoken:', accesstoken)
    console.log('GameURL:', GameURL)
    console.log('lang:', lang)

    return {
      uid: uid,
      accesstoken: accesstoken,
      GameURL: GameURL,
      lang: lang,
      sdk: sdk,
      gameID: gameID,
      gameEnv: gameEnv || ''
    }
  }

  // 关羽正式
  // https://cdn-web.hotgame.win/game/Box/half?sdk=chatie&gameID=206
  // 关羽测试
  // https://www.hotgame.win/box/chatie_test/half?sdk=chatie&gameID=206&game_env=dev

  // 水果机正式
  // https://cdn-web.hotgame.win/game/FruitSlots/half?sdk=chatie&gameID=202
  // 水果机测试
  // https://cdn-web.hotgame.win/game/FruitSlots/half?sdk=chatie&gameID=202&game_env=dev

  // 摩天轮正式
  // https://cdn-web.hotgame.win/game/GreedyStar/seven/?sdk=chatie&gameID=1153877559
  // 摩天轮测试
  // https://cdn-web.hotgame.win/game/GreedyStar/seven/?sdk=chatie&gameID=1153877559&game_env=dev

  // 足球正式
  // https://cdn-web.hotgame.win/game/FootballSlot/half/?sdk=chatie&gameID=215
  // 足球测试
  // https://cdn-web.hotgame.win/game/FootballSlot/half/?sdk=chatie&gameID=215&game_env=dev

  render() {

    // console.log("aaaa", this.props.location.query)
    let { uid, accesstoken, GameURL, lang, sdk, gameID, gameEnv } = this.getQuery()
    
    if (GameURL && GameURL.indexOf('?') === -1) {
      GameURL += '?ts=1'
    }

    if (!['ar', 'tr', 'en', 'ru', 'id'].includes(lang)) {
      lang = 'en'
    }

    if (lang === '') {
      lang = 'en'
    }

    // \u0026

    console.log(1111, uid)
    console.log(2222, accesstoken)
    console.log(3333, GameURL)
    console.log(4444, lang)

    return (
      <div className={`game1`}>
        <iframe
          className="app-games-iframe"
          id='app-games-iframe-main'
          src={`${GameURL}&sdk=${sdk}&gameID=${gameID}&game_env=${gameEnv}&uid=${uid}&accesstoken=${accesstoken}&lang=${lang}`}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
        </iframe>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/pages/app/game-reyou/index.js